export function mtFrontEndBuilder() {
    const $forms = document.querySelectorAll('.mt-feb-form');
    if (!$forms.length) return;

    $forms.forEach($form => {
        $form.addEventListener('submit', handleSubmit);
    });

    function handleSubmit(e) {
        e.preventDefault();
        console.log('submit');

        const $form = e.target;
        const formData = new FormData($form);
        const formDataObj = formDataToObject(formData);
        // console.log(formDataObj);

        const reqPayload = {
            id: $form.id || null,
            prompt: formDataObj.prompt || null,
            hint: compileHint(formDataObj)
        };

        console.log(reqPayload);
        window.mindtrip.showFrame(e, reqPayload);
    }
}


function formDataToObject(formData) {
    const obj = {};

    for (const [key, value] of formData.entries()) {
        if (Object.hasOwn(obj, key)) {
            if (!Array.isArray(obj[key])) {
                obj[key] = [obj[key]];
            }
            obj[key].push(value);
        } else {
            obj[key] = value;
        }
    }

    return obj;
}


function compileHint(formDataObj) {
    const sections = {};

    for (const [key, value] of Object.entries(formDataObj)) {
        const match = key.match(/^sec-(\d+)-(hint|multiselect)$/);
        if (!match) continue;

        const index = Number(match[1]);
        const field = match[2];

        if (!sections[index]) {
            sections[index] = { hint: '', values: [] };
        }

        if (field === 'hint') {
            sections[index].hint = String(value).trim();
        } else {
            const values = Array.isArray(value) ? value : [value];
            sections[index].values = values.map(v => String(v).trim()).filter(Boolean);
        }
    }

    const hint = Object.keys(sections)
        .sort((a, b) => Number(a) - Number(b))
        .filter(index => sections[index].values.length)
        .map(index => {
            const { hint: sectionHint, values } = sections[index];
            return [sectionHint, values.join(', ')].filter(Boolean).join(' ');
        })
        .join('. ');

    return hint || null;
}